import { render, staticRenderFns } from "./Deletion.vue?vue&type=template&id=6e143856&scoped=true&"
import script from "./Deletion.vue?vue&type=script&lang=js&"
export * from "./Deletion.vue?vue&type=script&lang=js&"
import style0 from "./Deletion.vue?vue&type=style&index=0&id=6e143856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e143856",
  null
  
)

export default component.exports